import React from "react";
import { ActionButton } from "../molecules/ActionButton";
import { IAccount } from "../../../common/accounts2";
import { isIntfAccessDenied, keyIntfShowAddressInAccounts } from "../../../common/disabledInterfaces";

interface ISettingsAccProps {
  account: IAccount;
  findCompanyName: (acc: IAccount) => string | undefined;
  setOpenDeletePopup: React.Dispatch<React.SetStateAction<boolean>>;
  setChosenAcc: React.Dispatch<React.SetStateAction<IAccount | null>>;
  setOpenChangePassPopup: React.Dispatch<React.SetStateAction<boolean>>;
  openAddUserPopup: () => void;
  userId: number;
}

export const SettingsAcc: React.FC<ISettingsAccProps> = ({
  account,
  findCompanyName,
  setOpenDeletePopup,
  setChosenAcc,
  setOpenChangePassPopup,
  openAddUserPopup,
  userId
}) => {
  const [showDropdown, setShowDropdown] = React.useState(false);

  const dropDownClassName = showDropdown
    ? "setting__dropdown setting__dropdown_show"
    : "setting__dropdown";

  function onShowDropdown() {
    setShowDropdown(true);
  }

  function onHideDropdown() {
    setShowDropdown(false);
  }

  function handleOpenDeletePopup() {
    setOpenDeletePopup(true);
    setChosenAcc(account);
  }

  function handleOpenChangePopup() {
    setOpenChangePassPopup(true);
    setChosenAcc(account);
  }


  function handleOpenAddUserPopup() {
    openAddUserPopup();
    setChosenAcc(account);
  }

  return (
    <li className="settings__acc-container">
      <div className="settings__acc-number">
        <p className="settings__text">
          <span>{account.externalAccountNum}</span>
        </p>
      </div>
      <div className="settings__acc-info">
      {isIntfAccessDenied(keyIntfShowAddressInAccounts)?null: <p className="settings__text">Адрес: {account.address}</p>}
        <p className="settings__text">УК: {findCompanyName(account)}</p>
        {/* <button className="data-card__button data-card__button_more">
          Подробнее
        </button> */}
      </div>
      <div
        className="setting__actions"
        onMouseOver={onShowDropdown}
        onMouseLeave={onHideDropdown}
      >
        <ActionButton />
        <div className={dropDownClassName}>
          {account.companyId !== 34 && (
            <button
              type="button"
              className="settings__dropdown-button"
              onClick={handleOpenChangePopup}
            >
              Сменить пароль
            </button>
          )}
          <button
            type="button"
            className="settings__dropdown-button"
            onClick={handleOpenDeletePopup}
          >
            Удалить
          </button>
          {(userId === account.masterUserId) && <button
            type="button"
            className="settings__dropdown-button"
            onClick={handleOpenAddUserPopup}
          >
            Добавить пользователя
          </button>}
        </div>
      </div>
    </li>
  );
};
